(() => {
  const VERSION = '20260827-v2';
  if (window.__MF_TASSEN_HERZHENKEL_MODE_VERSION__ === VERSION) return;
  window.__MF_TASSEN_HERZHENKEL_MODE_VERSION__ = VERSION;

  const MOCKUP = 'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-herzhenkel-tasse-mockup.png?v=1787767574';

  const setText = (el, value) => {
    if (el && el.textContent !== value) el.textContent = value;
  };

  const setHtml = (el, value) => {
    if (el && el.innerHTML !== value) el.innerHTML = value;
  };

  function patchCopy(root) {
    const title = root.querySelector('.intro h1');
    setHtml(title, 'Deine Herzhenkel-Tasse.<br><em>Rundum gestaltet.</em>');

    const tip = root.querySelector('.tip-box');
    const steps = tip?.querySelectorAll('span');
    setText(steps?.[0], '1. Foto und Text einfügen & ausrichten');
    setText(steps?.[1], '2. Vorschau prüfen und Tasse drehen');
    setText(steps?.[2], '3. Gestaltung in den Warenkorb legen');

    root.querySelectorAll('.summary-box strong, .cart-line strong').forEach((el) => {
      const text = (el.textContent || '').trim().toLowerCase();
      if (text.includes('tasse') && el.textContent !== 'Herzhenkel-Tasse') {
        el.textContent = 'Herzhenkel-Tasse';
      }
    });
  }

  function ensurePreview(root) {
    const controls = root.querySelector('.controls-card');
    if (!controls) return;

    if (!root.querySelector('.mf-hh-designer-product')) {
      const preview = document.createElement('div');
      preview.className = 'mf-hh-designer-product';
      preview.innerHTML = '<div class="mf-hh-designer-product__copy"><strong>Deine Herzhenkel-Tasse</strong><span>Weiße Keramiktasse mit romantischem Herzhenkel</span></div><div class="mf-hh-designer-product__image"><img src="' + MOCKUP + '" alt="Weiße Herzhenkel-Tasse ohne Motiv"></div>';
      controls.insertBefore(preview, controls.firstElementChild || null);
    }

    if (!root.getElementById('mf-hh-designer-style')) {
      const style = document.createElement('style');
      style.id = 'mf-hh-designer-style';
      style.textContent = '.mf-hh-designer-product{display:grid;grid-template-columns:minmax(0,1fr) 88px;align-items:center;gap:12px;margin:0 0 15px;padding:11px 12px;border:1px solid rgba(255,255,255,.16);border-left:3px solid #f58220;border-radius:10px;background:#1a1b1d}.mf-hh-designer-product__copy{display:grid;gap:3px;min-width:0}.mf-hh-designer-product__copy strong{color:#fff;font-size:13px;line-height:1.2}.mf-hh-designer-product__copy span{color:#bfc0c2;font-size:10px;line-height:1.35}.mf-hh-designer-product__image{display:flex;align-items:center;justify-content:center;height:64px;border-radius:7px;background:#0e0f11;overflow:hidden}.mf-hh-designer-product__image img{display:block;width:92%;height:92%;object-fit:contain}@media(max-width:749px){.mf-hh-designer-product{grid-template-columns:minmax(0,1fr) 72px;padding:9px 10px}.mf-hh-designer-product__image{height:54px}.mf-hh-designer-product__copy strong{font-size:12px}.mf-hh-designer-product__copy span{font-size:9px}}';
      root.appendChild(style);
    }
  }

  function patchHost(host) {
    if (!host || host.dataset.mfMugMode !== 'herzhenkel') return false;
    host.dataset.mfHerzhenkelImage = MOCKUP;

    const root = host.shadowRoot;
    if (!root) return false;

    patchCopy(root);
    ensurePreview(root);

    if (host.__mfHerzhenkelObserver) {
      host.__mfHerzhenkelObserver.disconnect();
      host.__mfHerzhenkelObserver = null;
    }

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (!host.isConnected) {
          observer.disconnect();
          return;
        }
        patchCopy(root);
        ensurePreview(root);
      });
    });

    observer.observe(root, { childList: true, subtree: true });
    host.__mfHerzhenkelObserver = observer;
    return true;
  }

  function boot() {
    document.querySelectorAll('[data-mf-tassen-designer-host][data-mf-mug-mode="herzhenkel"]').forEach((host) => {
      const root = host.shadowRoot;
      if (!root) return;

      if (!host.__mfHerzhenkelObserver) {
        patchHost(host);
      } else {
        patchCopy(root);
        ensurePreview(root);
      }
    });
  }

  window.__MF_TASSEN_HERZHENKEL_BOOT__ = boot;
  document.addEventListener('mf:herzhenkel-boot', boot);
  [0, 100, 250, 600, 1200, 2500].forEach((ms) => setTimeout(boot, ms));

  if (!window.__MF_HERZHENKEL_FETCH__) {
    window.__MF_HERZHENKEL_FETCH__ = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = async (input, options = {}) => {
      try {
        const url = typeof input === 'string' ? input : String(input?.url || '');
        const method = String(options.method || 'GET').toUpperCase();
        const body = options.body;
        const activeHost = document.querySelector('[data-mf-tassen-designer-host][data-mf-mug-mode="herzhenkel"]');
        if (activeHost && method === 'POST' && /\/cart\/add\.js(?:\?|$)/.test(url) && body instanceof FormData) {
          if (!body.has('properties[Tassenform]')) body.append('properties[Tassenform]', 'Herzhenkel-Tasse');
          if (!body.has('properties[_MF Tassenform-ID]')) body.append('properties[_MF Tassenform-ID]', 'herzhenkel');
        }
      } catch (error) {
        console.warn('[MF Herzhenkel]', error);
      }
      return originalFetch(input, options);
    };
  }
})();
